import { render } from "./ModalTransporterDelete.vue?vue&type=template&id=6337d1e1"
import script from "./ModalTransporterDelete.vue?vue&type=script&lang=js"
export * from "./ModalTransporterDelete.vue?vue&type=script&lang=js"

import "./ModalTransporterDelete.vue?vue&type=style&index=0&id=6337d1e1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__